import { createRoutesFromElements } from 'react-router-dom';

import { routeTree } from '@/routes/route-tree';

/**
 * The route config shared by every entry point: App pairs it with
 * createBrowserRouter, AppDemo with createHashRouter (so the demo build runs
 * from file://), and the route tests with createMemoryRouter.
 *
 * The history type is chosen when the router is created, which is why this
 * module exports a route config rather than a rendered component.
 */
export const routes = createRoutesFromElements(routeTree);
